import './App.scss';
import Header from '../Tools/Header/Header';
// import Footer from '../Tools/Footer/Footer';
import Menu from '../Tools/Menu/Menu';
import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Offline, Online } from "react-detect-offline";
import Main from './Main';

// blogs images
import unlock from '../Images/unlock.png'
import reload from '../Images/reload.png'
import callbtn from '../Images/telephone.png'
import PopUp from '../Tools/PopUp/PopUp';
import Footer from '../Tools/Footer/Footer';

function App() {
  const [showMenu, setShowMenu] = useState(false)
  const [showPopUp, setShowPopUp] = useState(false)
  const [showVerify, setShowVerify] = useState(true)
  const [status, setStatus] = useState(true);
  const navigate = useNavigate()
  const location = useLocation()
  const [BookAnAppointment, setBookAnAppointment] = useState(true);

  const url = new URL(window.location.href);
  const [CitiesData, setCitiesData] = useState({});

  const [CitiePhone, setCitiePhone] = useState(url.searchParams.get('cp') ? url.searchParams.get('cp') : "866-605-4089");
  useEffect(() => {
    (async () => {

      // google //
      if (url.searchParams.get('spg') == "g") {
        const CitiesZipGoogle2 = (await import('./CitiesZipGoogle2.js')).default;
        if (CitiesZipGoogle2.find(a => a.ID == url.searchParams.get('cd'))) {
          const res = await fetch(`https://maps.googleapis.com/maps/api/geocode/json?address=${CitiesZipGoogle2.find(a => a.ID == url.searchParams.get('cd')).ZC}&key=AIzaSyC_XBMupYyuYy-f1TGdo32rsoHBhSMWPK0&language=en`, { method: 'GET', })
          const data = await res.json()
          // console.log(data.results[0])
          setCitiesData({
            "ID": CitiesData.ID,
            "City":
              data.results[0].address_components.find(a => a.types.find(a => a == 'locality')) ?
                data.results[0].address_components.find(a => a.types.find(a => a == 'locality')).long_name :
                data.results[0].formatted_address.split(',')[0] + ", " + data.results[0].formatted_address.split(',')[1].substring(0, 3),
            "Full":
              data.results[0].address_components.find(a => a.types.find(a => a == 'locality')) ?
                data.results[0].address_components.find(a => a.types.find(a => a == 'locality')).long_name + ', ' + data.results[0].address_components.find(a => a.types.find(a => a == 'administrative_area_level_1')).long_name :
                data.results[0].formatted_address.split(',')[0] + ", " + data.results[0].formatted_address.split(',')[1].substring(0, 3),

          })
        } else {
          const CitiesDataGoogle = (await import('./CitiesDataGoogle.js')).default;
          if (CitiesDataGoogle.find(a => a.ID == url.searchParams.get('cd'))) {
            setCitiesData(CitiesDataGoogle.find(a => a.ID == url.searchParams.get('cd')))
          } else {
            setCitiesData({})
          }
        }
      }

      // Microsoft //
      if (url.searchParams.get('spg') == "m") {
        const CitiesZipMS2 = (await import('./CitiesZipMS2.js')).default;
        if (CitiesZipMS2.find(a => a.ID == url.searchParams.get('cd'))) {
          const res = await fetch(`https://maps.googleapis.com/maps/api/geocode/json?address=${CitiesZipMS2.find(a => a.ID == url.searchParams.get('cd')).ZC}&key=AIzaSyC_XBMupYyuYy-f1TGdo32rsoHBhSMWPK0&language=en`, { method: 'GET', })
          const data = await res.json()
          setCitiesData({
            "ID": CitiesZipMS2.find(a => a.ID == url.searchParams.get('cd')).ID,
            "City":
              data.results[0].address_components.find(a => a.types.find(a => a == 'locality')) ?
                data.results[0].address_components.find(a => a.types.find(a => a == 'locality')).long_name :
                data.results[0].formatted_address.split(',')[0] + ", " + data.results[0].formatted_address.split(',')[1].substring(0, 3),
            "Full":
              data.results[0].address_components.find(a => a.types.find(a => a == 'locality')) ?
                data.results[0].address_components.find(a => a.types.find(a => a == 'locality')).long_name + ', ' + data.results[0].address_components.find(a => a.types.find(a => a == 'administrative_area_level_1')).long_name :
                data.results[0].formatted_address.split(',')[0] + ", " + data.results[0].formatted_address.split(',')[1].substring(0, 3),

          })
        } else {
          const CitiesDataMS = (await import('./CitiesDataMS.js')).default;
          if (CitiesDataMS.find(a => a.ID == url.searchParams.get('cd'))) {
            setCitiesData(CitiesDataMS.find(a => a.ID == url.searchParams.get('cd')))
          } else {
            setCitiesData({})
          }
        }
      }


      // const res1 = await fetch('https://bhocs-10ec.restdb.io/', {
      //   method: 'GET',
      //   headers: {
      //     'Access-Control-Allow-Origin': '*',
      //     'Content-Type': 'application/json',
      //     'x-apikey': '66fddf40f368d41d0d577784',
      //     'Access-Control-Allow-Credentials': 'true',
      //     'cache-control':'no-cache',
      //     'Access-Control-Allow-Methods': 'GET,HEAD,OPTIONS,POST,PUT',
      //     'Access-Control-Allow-Headers': 'Access-Control-Allow-Headers, Origin,Accept, X-Requested-With, Content-Type, Access-Control-Request-Method, Access-Control-Request-Headers',
      //   }
      // });
      // const data1 = await res1.json()
      // console.log(data1)



      if (showVerify == true) {
        document.body.style.overflow = "hidden"
        document.body.style.overflow = "scroll"
      } else {
        document.body.style.overflow = "scroll"
      }
      setTimeout(() => {
        const checkpop = localStorage.getItem("showPopUp");
        if (checkpop) {
          setShowPopUp(false)
        } else {
          setShowPopUp(true)
        }
      }, 5000);
      window.addEventListener('online', () => setStatus(true))
      window.addEventListener('offline', () => setStatus(false))
    })();
  }, [showVerify, status]);

  const navigateTo = (page) => {
    navigate('/' + page)
    setShowMenu(false)

  }
  const locationsMain = [
    {
      "Location": "Austin",
      "Phone": "737-367-2143",
      "Address": [
        {
          "Location1": "Austin",
          "Address1": "9415 Burnet Rd, Austin, Texas 78758",
        },
        {
          "Location1": "San Antonio",
          "Address1": "9504 N IH-35, San Antonio, TX 78233",
        },
      ],
      "Map": "https://www.google.com/maps/d/u/0/embed?mid=1ZFzBzklHnjRzKFG32H-Wn9TxmmpdSu8&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Chicago",
      "Phone": "872-288-0977",
      "Address": [
        {
          "Location1": "Chicago",
          "Address1": "2211 N Elston Ave, Chicago, IL 60614",
        }
      ],
      "Map": "https://www.google.com/maps/d/u/0/embed?mid=1Y2d_hgj3Z2rnaUFE90sd_RmsM456iVI&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Connecticut",
      "Phone": "475-447-1126",
      "Address": [
        {
          "Location1": "Hartford",
          "Address1": "64 Oakland Ave, East Hartford, CT 06108",
        },
        {
          "Location1": "Hamden",
          "Address1": "2666 State St, Hamden, CT 06517",
        },
      ],
      "Map": "https://www.google.com/maps/d/u/0/embed?mid=1arTs8xd0v35vvinYSHJY5y2cU9EPi7g&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Houston",
      "Phone": "346-614-4773",
      "Address": [
        {
          "Location1": "Houston",
          "Address1": "2705 Blodgett St, Houston, TX 77004",
        },
      ],
      "Map": "https://www.google.com/maps/d/u/0/embed?mid=1KYM_Tnx3zFBA9vvUnimOYgc3YHLlLBE&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Kansas",
      "Phone": "913-404-4872",
      "Address": [
        {
          "Location1": "Kansas",
          "Address1": "3947 Broadway St, Kansas City, MO 64111",
        },
      ],
      "Map": "https://www.google.com/maps/d/u/0/embed?mid=1cyZUyG54v6vYltik3L6Zbfpd7Cm6gW0&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Los Angeles",
      "Phone": "213-698-5905",
      "Address": [
        {
          "Location1": "Valley",
          "Address1": "1271 Saviers Rd, Oxnard, CA 93033",
        },
        {
          "Location1": "Los Angeles",
          "Address1": "6222 Wilshire Blvd, Los Angeles, CA 90048",
        },
        {
          "Location1": "Riverside",
          "Address1": "3890 11th St, Riverside, CA 92501",
        },
      ],
      "Map": "https://www.google.com/maps/d/u/0/embed?mid=1igOR7boZkzmdyNwUcncKxxA65IggcHE&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Minneapolis",
      "Phone": "651-273-1473",
      "Address": [
        {
          "Location1": "Minneapolis",
          "Address1": "201 Main St SE, Minneapolis, MN 55414",
        },
      ],
      "Map": "https://www.google.com/maps/d/u/0/embed?mid=12fYx_1i1hARDMU9SIht0RVfutlIhFfM&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "New Jersey",
      "Phone": "732-466-6572",
      "Address": [
        {
          "Location1": "Moorestown",
          "Address1": "300 Harper Dr, Moorestown, NJ 08057",
        },
        {
          "Location1": "Newark",
          "Address1": "390 Broad St, Newark, NJ 07104",
        },
      ],
      "Map": "https://www.google.com/maps/d/u/0/embed?mid=1wCzvOW3l5LHsYiJ8weh2xoTKcaS8nb8&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Orlando",
      "Phone": "407-337-2852",
      "Address": [
        {
          "Location1": "Orlando",
          "Address1": "37 N Orange Ave, Orlando, FL 32801",
        },
        {
          "Location1": "Jacksonville",
          "Address1": "4168 Southpoint Park Way, Jacksonville, FL 32216",
        },
      ],
      "Map": "https://www.google.com/maps/d/u/0/embed?mid=1NjUXcA6OX2tJZ-Xht56H0wZZNLiGbeQ&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Seattle",
      "Phone": "206-875-2251",
      "Address": [
        {
          "Location1": "Seattle",
          "Address1": "464 12th Ave, Seattle, WA 98122",
        }
      ],
      "Map": "https://www.google.com/maps/d/u/0/embed?mid=1wpt9MtPAqDTtBJ8BGNjpjdKnSZ4IYxA&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Saint Louis",
      "Phone": "314-886-8145",
      "Address": [
        {
          "Location1": "Saint Louis",
          "Address1": "399 N Euclid Ave, Saint Louis, MO 63108",
        }
      ],
      "Map": "https://www.google.com/maps/d/u/0/embed?mid=15wIgRS6l1GFxtX5Ongf6ArLwOsAcML0&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Tampa",
      "Phone": "813-733-7346",
      "Address": [
        {
          "Location1": "Tampa",
          "Address1": "1902 W Main St, Tampa, FL 33607",
        },
        {
          "Location1": "Fort Myers",
          "Address1": "15050 Elderberry Ln, Fort Myers, FL 33907",
        },
      ],
      "Map": "https://www.google.com/maps/d/u/0/embed?mid=1sLBr2KXbf8fs1MWdeT9eGkrQDZ-gqXk&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Denver",
      "Phone": "720-704-2987",
      "Address": [
        {
          "Location1": "Denver",
          "Address1": "543 Santa Fe Dr, Denver, CO 80204",
        }
      ],
      "Map": "https://www.google.com/maps/d/u/3/embed?mid=1-dZYn4IqFRsZTQoHlvmE7CAay5fosYQ&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Charlotte",
      "Phone": "980-436-3595",
      "Address": [
        {
          "Location1": "Charlotte",
          "Address1": "4326 Monroe Rd, Charlotte, NC 28205",
        }
      ],
      "Map": "https://www.google.com/maps/d/u/3/embed?mid=1mhFU5wqgrPgYF_kqrRbwxfZT9SGr_BI&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Nashville",
      "Phone": "615-437-6099",
      "Address": [
        {
          "Location1": "Nashville",
          "Address1": "2910 Poston Ave, Nashville, TN 37203",
        }
      ],
      "Map": "https://www.google.com/maps/d/u/3/embed?mid=1b1273439kLELw9wSSiqD-_WhlAKGl18&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Dallas",
      "Phone": "469-902-3045",
      "Address": [
        {
          "Location1": "Dallas",
          "Address1": "5701 Maple Ave, Dallas, TX 75235",
        }
      ],
      "Map": "https://www.google.com/maps/d/u/3/embed?mid=1Jq7olr9nIOOlBvrge9gBtQZ1gv38eSk&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Atlanta",
      "Phone": "678-680-6382",
      "Address": [
        {
          "Location1": "Atlanta",
          "Address1": "1200 White St SW, Atlanta, GA 30310",
        }
      ],
      "Map": "https://www.google.com/maps/d/u/3/embed?mid=1sIJWXQRLTPmw4YVHmgahsrJWSgd1VEM&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "San Fransisco",
      "Phone": "415-340-5954",
      "Address": [
        {
          "Location1": "San Fransisco",
          "Address1": "1485 Bay Shore Blvd, San Francisco, CA 94124",
        },
        {
          "Location1": "Sacramento",
          "Address1": "2120 P St, Sacramento, CA 95816",
        },
      ],
      "Map": "https://www.google.com/maps/d/u/3/embed?mid=1P2j6c4nBHDRM-AtgEDKq0HXXFq0TcIM&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "San Jose",
      "Phone": "408-539-2676",
      "Address": [
        {
          "Location1": "San Jose",
          "Address1": "695 N 1st St, San Jose, CA 95112",
        }
      ],
      "Map": "https://www.google.com/maps/d/u/3/embed?mid=1VTJ5eC5cJ1lvDHm3-xJ-8DaTl412cv8&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Detroit",
      "Phone": "313-922-7886",
      "Address": [
        {
          "Location1": "Detroit",
          "Address1": "438 Macomb St, Detroit, MI 48226",
        }
      ],
      "Map": "https://www.google.com/maps/d/u/3/embed?mid=1EbsUpXTpW8B457T-xz2aBMfyTDb7EYs&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "New York",
      "Phone": "516-970-4945",
      "Address": [
        {
          "Location1": "New York",
          "Address1": "10657 160th St, Jamaica, NY 11433",
        },
        {
          "Location1": "Farmingdale",
          "Address1": "2357 Broadhollow Rd, Farmingdale, NY 11735",
        },
      ],
      "Map": "https://www.google.com/maps/d/u/3/embed?mid=17OjSFSNGhqK3w-aOCSkHNgDzV8ybfjc&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Ohio",
      "Phone": "330-295-3631",
      "Address": [
        {
          "Location1": "Fort Wayne",
          "Address1": "6069 Stellhorn Rd, Fort Wayne, IN 46815",
        },
        {
          "Location1": "Toledo",
          "Address1": "5153 Glendale Ave, Toledo, OH 43614",
        },
        {
          "Location1": "Dayton",
          "Address1": "3739 Inpark Cir, Dayton, OH 45414",
        },
      ],
      "Map": "https://www.google.com/maps/d/u/3/embed?mid=1T_-ChddVtp0sNncfKQ1_eqiV2h6tCxc&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Philadelphia",
      "Phone": "215-261-7009",
      "Address": [
        {
          "Location1": "Philadelphia",
          "Address1": "1501 N Broad St, Philadelphia, PA 19122",
        },
      ],
      "Map": "https://www.google.com/maps/d/u/3/embed?mid=1D8wzDRrVB_qzrwo_8RkQA30RgZu0Q2I&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Maryland",
      "Phone": "443-381-6892",
      "Address": [
        {
          "Location1": "College Park",
          "Address1": "4907 Niagara Rd, College Park, MD 20740",
        },
      ],
      "Map": "https://www.google.com/maps/d/u/3/embed?mid=1hFBKavqDPHMd0GUtJ-dU5YcIwaZPHZg&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Miami",
      "Phone": "786-981-8328",
      "Address": [
        {
          "Location1": "Miami",
          "Address1": "7275 NW 1st Ct, Miami, FL 33150",
        },
      ],
      "Map": "https://www.google.com/maps/d/u/3/embed?mid=1-hiS50ZCrpLPWXbYvKYv5tJyxeyogbo&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Sacramento",
      "Phone": "916-674-0535",
      "Address": [
        {
          "Location1": "Sacramento",
          "Address1": "646 El Camino Ave, Sacramento, CA 95815",
        },
      ],
      "Map": "https://www.google.com/maps/d/u/3/embed?mid=1f4Ra1abEjnnszAfIdOD2KJJTEde07R0&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Cleveland",
      "Phone": "216-424-5487",
      "Address": [
        {
          "Location1": "Cleveland",
          "Address1": "323 W Lakeside Ave, Cleveland, OH 44113",
        },
      ],
      "Map": "https://www.google.com/maps/d/u/0/embed?mid=1yNBBqJvjaTYSULO-rnfEyRDfpLDl8_k&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Pittsburgh",
      "Phone": ["412-873-2358", "412-838-4350"],
      "Address": [
        {
          "Location1": "Pittsburgh",
          "Address1": "503 Martindale St, Pittsburgh, PA 15212",
        },
      ],
      "Map": "https://www.google.com/maps/d/u/4/embed?mid=1BApI-jAERBFAmwEZFhwS147kwCJzpQo&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Boston",
      "Phone": "857-336-0686",
      "Address": [
        {
          "Location1": "Boston",
          "Address1": "350 Longwood Ave, Boston, MA 02115",
        },
      ],
      "Map": "https://www.google.com/maps/d/u/4/embed?mid=1yho9ZClpYYs5-XVsvPoakgClI1cGW00&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Knoxville",
      "Phone": "865-346-4543",
      "Address": [
        {
          "Location1": "Knoxville",
          "Address1": "311 Highway Ave, Knoxville, TN 37920",
        },
      ],
      "Map": "https://www.google.com/maps/d/u/4/embed?mid=18WO5IaIoTUxbT94-cyxay_cSjU7MG0I&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Phoenix",
      "Phone": "602-780-2602",
      "Address": [
        {
          "Location1": "Phoenix",
          "Address1": "4116 N 7th Ave, Phoenix, AZ 85013",
        },
      ],
      "Map": "https://www.google.com/maps/d/u/4/embed?mid=1Msxuhd3bUNheRJDX7TytN94Bb4yvMdE&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Milwaukee",
      "Phone": "414-348-5105",
      "Address": [
        {
          "Location1": "Milwaukee",
          "Address1": "2500 W Layton Ave, Milwaukee, WI 53221",
        },
      ],
      "Map": "https://www.google.com/maps/d/u/3/embed?mid=1UhLnu-LJ2ZJs75rlYEslvH_k0rwDywQ&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Raleigh",
      "Phone": "919-804-0651",
      "Address": [
        {
          "Location1": "Raleigh",
          "Address1": "3700 Six Forks Rd, Raleigh, NC 27609",
        },
      ],
      "Map": "https://www.google.com/maps/d/u/3/embed?mid=1mU80sHsrx3sajxGM2kUjBAflBUJSYbU&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Birmingham",
      "Phone": "919-551-6312",
      "Address": [
        {
          "Location1": "Birmingham",
          "Address1": "1157 Bankhead Hwy W, Birmingham, AL 35204",
        },
      ],
      "Map": "https://www.google.com/maps/d/u/3/embed?mid=1QR-lb-vzRwo6JqsxoALu0-j4RXq8Hcw&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "San Diego",
      "Phone": "619-649-6084",
      "Address": [
        {
          "Location1": "San Diego",
          "Address1": "8745 Aero Dr, San Diego, CA 92123",
        },
      ],
      "Map": "https://www.google.com/maps/d/u/3/embed?mid=1t041CxbPzWmdnVenmhzZGIwlfxETi7E&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Norfolk",
      "Phone": "757-750-1927",
      "Address": [
        {
          "Location1": "Norfolk",
          "Address1": "160 Newtown Rd, Virginia Beach, VA 23462",
        },
      ],
      "Map": "https://www.google.com/maps/d/u/3/embed?mid=1QR-lb-vzRwo6JqsxoALu0-j4RXq8Hcw&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Cincinnati",
      "Phone": "513-957-4618",
      "Address": [
        {
          "Location1": "Cincinnati",
          "Address1": "4960 Ridge Ave, Cincinnati, OH 45209",
        },
      ],
      "Map": "https://www.google.com/maps/d/u/3/embed?mid=1007Wevk9UO7H_NF5el9BicLFmUCr-Ms&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Monsey",
      "Phone": "845-630-0742",
      "Address": [
        {
          "Location1": "Monsey",
          "Address1": "85 Chestnut Ridge Rd, Montvale, NJ 07645",
        },
      ],
      "Map": "https://www.google.com/maps/d/u/3/embed?mid=1ruNj0ARlxKW5nXKHT2J5OGeA8b-03pU&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Portland",
      "Phone": "503-766-4807",
      "Address": [
        {
          "Location1": "Portland",
          "Address1": "4425 NE Broadway St, Portland, OR 97213",
        },
      ],
      "Map": "https://www.google.com/maps/d/u/3/embed?mid=1rNiB_ySheM5dd5ID9EUfOFilUjFg0UQ&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "West Palm Beach",
      "Phone": "561-203-4681",
      "Address": [
        {
          "Location1": "West Palm Beach",
          "Address1": "927 45th St, West Palm Beach, FL 33407",
        },
      ],
      "Map": "https://www.google.com/maps/d/u/3/embed?mid=1NJytl2FwaGzC4bZ4vu2TbXZrkrMj4GA&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Oklahoma City",
      "Phone": "405-458-8702",
      "Address": [
        {
          "Location1": "Oklahoma City",
          "Address1": "3810 N Tulsa Ave, Oklahoma City, OK 73112",
        },
      ],
      "Map": "https://www.google.com/maps/d/u/3/embed?mid=1fUVMVNlHc47pYNN1YR46BQkF23pryl0&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Indianapolis",
      "Phone": "317-360-5284",
      "Address": [
        {
          "Location1": "Indianapolis",
          "Address1": "5935 S Emerson Ave, Indianapolis, IN 46237",
        },
      ],
      "Map": "https://www.google.com/maps/d/u/1/embed?mid=1BxTUns9WQX4vztBWS0UhLcOlK7kBHJU&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Louisville",
      "Phone": "502-443-1259",
      "Address": [
        {
          "Location1": "Louisville",
          "Address1": "2420 Frankfort Ave, Louisville, KY 40206",
        },
      ],
      "Map": "https://www.google.com/maps/d/u/1/embed?mid=1ifIMqzL5jRSg4NBMY_bdONq36UDzm_Q&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Salt Lake City",
      "Phone": "801-515-3538",
      "Address": [
        {
          "Location1": "Salt Lake City",
          "Address1": "325 Hope Ave, Salt Lake City, UT 84115",
        },
      ],
      "Map": "https://www.google.com/maps/d/u/1/embed?mid=1R-XIKyV0rDl14--MUC00lCdUgK-Nr48&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Las Vegas",
      "Phone": "702-935-6585",
      "Address": [
        {
          "Location1": "Las Vegas",
          "Address1": "3010 W Charleston Blvd, Las Vegas, NV 89102",
        },
      ],
      "Map": "https://www.google.com/maps/d/u/1/embed?mid=1t-jtHfJK5Pq0xkWOB0jNOUptMN3kb9Y&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Pensacola",
      "Phone": "850-821-7297",
      "Address": [
        {
          "Location1": "Pensacola",
          "Address1": "5151 N 9th Ave, Pensacola, FL 32504",
        },
      ],
      "Map": "https://www.google.com/maps/d/u/1/embed?mid=1aDnrWu--AvpT-KgjgOFvDld9uf0bWOo&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Columbia SC",
      "Phone": "803-618-0863",
      "Address": [
        {
          "Location1": "Columbia SC",
          "Address1": "301 Greystone Blvd, Columbia, SC 29210",
        },
      ],
      "Map": "https://www.google.com/maps/d/u/1/embed?mid=1FLOLJRWgTSK4Al9racgtAgroV1Al0ho&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Greenville",
      "Phone": "864-528-3916",
      "Address": [
        {
          "Location1": "Greenville",
          "Address1": "477 Haywood Rd, Greenville, SC 29607",
        },
      ],
      "Map": "https://www.google.com/maps/d/u/1/embed?mid=14Bfv3ruWHSMU-yNNygyhlY0NlPf67bE&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Albuquerque",
      "Phone": "505-535-4397",
      "Address": [
        {
          "Location1": "Albuquerque",
          "Address1": "400 Gold Ave SW, Albuquerque, NM 87102",
        },
      ],
      "Map": "https://www.google.com/maps/d/u/1/embed?mid=1QPWWvAkdgh-wHkZSG4cC8aTjdbhP3J4&ehbc=2E312F&noprof=1",
    },

    {
      "Location": "Chattanooga",
      "Phone": "423-922-5411",
      "Address": [
        {
          "Location1": "Chattanooga",
          "Address1": "2101 Chestnut St, Chattanooga, TN 37408",
        },
      ],
      "Map": "https://www.google.com/maps/d/u/1/embed?mid=1S1zsAvFNLN37TC8Ih0IstKmAfAxYN4M&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Tuscon",
      "Phone": "520-424-7810",
      "Address": [
        {
          "Location1": "Tuscon",
          "Address1": "3594 E Lincoln St, Tucson, AZ 85714",
        },
      ],
      "Map": "https://www.google.com/maps/d/u/1/embed?mid=1-Qija8eglCmUNxUDpZux8pj-bH3GQiQ&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "San Antonio",
      "Phone": "210-361-4393",
      "Address": [
        {
          "Location1": "San Antonio",
          "Address1": "5631 University Heights Blvd, San Antonio, TX 78249",
        },
      ],
      "Map": "https://www.google.com/maps/d/u/1/embed?mid=1AuqzHiOAZMwFHM7GVKNbvpXsot3LKoQ&ehbc=2E312F&noprof=1",
    },
  ]

  const locationsMain2Chimney = [
    {
      "Location": "Austin",
      "Phone": "737-345-0819",
      "Address": [
        {
          "Location1": "Austin",
          "Address1": "9415 Burnet Rd, Austin, Texas 78758",
        },
        {
          "Location1": "San Antonio",
          "Address1": "9504 N IH-35, San Antonio, TX 78233",
        },
      ],
      "Map": "https://www.google.com/maps/d/u/0/embed?mid=1ZFzBzklHnjRzKFG32H-Wn9TxmmpdSu8&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Chicago",
      "Phone": "872-324-3260",
      "Address": [
        {
          "Location1": "Chicago",
          "Address1": "2211 N Elston Ave, Chicago, IL 60614",
        }
      ],
      "Map": "https://www.google.com/maps/d/u/0/embed?mid=1Y2d_hgj3Z2rnaUFE90sd_RmsM456iVI&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Connecticut",
      "Phone": "475-255-2530",
      "Address": [
        {
          "Location1": "Hartford",
          "Address1": "64 Oakland Ave, East Hartford, CT 06108",
        },
        {
          "Location1": "Hamden",
          "Address1": "2666 State St, Hamden, CT 06517",
        },
      ],
      "Map": "https://www.google.com/maps/d/u/0/embed?mid=1arTs8xd0v35vvinYSHJY5y2cU9EPi7g&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Houston",
      "Phone": "346-597-3651",
      "Address": [
        {
          "Location1": "Houston",
          "Address1": "2705 Blodgett St, Houston, TX 77004",
        },
      ],
      "Map": "https://www.google.com/maps/d/u/0/embed?mid=1KYM_Tnx3zFBA9vvUnimOYgc3YHLlLBE&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Kansas",
      "Phone": "913-395-8294",
      "Address": [
        {
          "Location1": "Kansas",
          "Address1": "3947 Broadway St, Kansas City, MO 64111",
        },
      ],
      "Map": "https://www.google.com/maps/d/u/0/embed?mid=1cyZUyG54v6vYltik3L6Zbfpd7Cm6gW0&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Los Angeles",
      "Phone": "213-408-7573",
      "Address": [
        {
          "Location1": "Valley",
          "Address1": "1271 Saviers Rd, Oxnard, CA 93033",
        },
        {
          "Location1": "Los Angeles",
          "Address1": "6222 Wilshire Blvd, Los Angeles, CA 90048",
        },
        {
          "Location1": "Riverside",
          "Address1": "3890 11th St, Riverside, CA 92501",
        },
      ],
      "Map": "https://www.google.com/maps/d/u/0/embed?mid=1igOR7boZkzmdyNwUcncKxxA65IggcHE&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Minneapolis",
      "Phone": "651-650-4446",
      "Address": [
        {
          "Location1": "Minneapolis",
          "Address1": "201 Main St SE, Minneapolis, MN 55414",
        },
      ],
      "Map": "https://www.google.com/maps/d/u/0/embed?mid=12fYx_1i1hARDMU9SIht0RVfutlIhFfM&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "New Jersey",
      "Phone": "732-538-9044",
      "Address": [
        {
          "Location1": "Moorestown",
          "Address1": "300 Harper Dr, Moorestown, NJ 08057",
        },
        {
          "Location1": "Newark",
          "Address1": "390 Broad St, Newark, NJ 07104",
        },
      ],
      "Map": "https://www.google.com/maps/d/u/0/embed?mid=1wCzvOW3l5LHsYiJ8weh2xoTKcaS8nb8&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Orlando",
      "Phone": "407-501-7992",
      "Address": [
        {
          "Location1": "Orlando",
          "Address1": "37 N Orange Ave, Orlando, FL 32801",
        },
        {
          "Location1": "Jacksonville",
          "Address1": "4168 Southpoint Park Way, Jacksonville, FL 32216",
        },
      ],
      "Map": "https://www.google.com/maps/d/u/0/embed?mid=1NjUXcA6OX2tJZ-Xht56H0wZZNLiGbeQ&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Seattle",
      "Phone": "206-589-1976",
      "Address": [
        {
          "Location1": "Seattle",
          "Address1": "464 12th Ave, Seattle, WA 98122",
        }
      ],
      "Map": "https://www.google.com/maps/d/u/0/embed?mid=1wpt9MtPAqDTtBJ8BGNjpjdKnSZ4IYxA&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Saint Louis",
      "Phone": "314-328-7283",
      "Address": [
        {
          "Location1": "Saint Louis",
          "Address1": "399 N Euclid Ave, Saint Louis, MO 63108",
        }
      ],
      "Map": "https://www.google.com/maps/d/u/0/embed?mid=15wIgRS6l1GFxtX5Ongf6ArLwOsAcML0&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Tampa",
      "Phone": "813-945-8882",
      "Address": [
        {
          "Location1": "Tampa",
          "Address1": "1902 W Main St, Tampa, FL 33607",
        },
        {
          "Location1": "Fort Myers",
          "Address1": "15050 Elderberry Ln, Fort Myers, FL 33907",
        },
      ],
      "Map": "https://www.google.com/maps/d/u/0/embed?mid=1sLBr2KXbf8fs1MWdeT9eGkrQDZ-gqXk&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Denver",
      "Phone": "720-864-0553",
      "Address": [
        {
          "Location1": "Denver",
          "Address1": "543 Santa Fe Dr, Denver, CO 80204",
        }
      ],
      "Map": "https://www.google.com/maps/d/u/3/embed?mid=1-dZYn4IqFRsZTQoHlvmE7CAay5fosYQ&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Charlotte",
      "Phone": "704-538-4873",
      "Address": [
        {
          "Location1": "Charlotte",
          "Address1": "4326 Monroe Rd, Charlotte, NC 28205",
        }
      ],
      "Map": "https://www.google.com/maps/d/u/3/embed?mid=1mhFU5wqgrPgYF_kqrRbwxfZT9SGr_BI&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Nashville",
      "Phone": "615-697-4175",
      "Address": [
        {
          "Location1": "Nashville",
          "Address1": "2910 Poston Ave, Nashville, TN 37203",
        }
      ],
      "Map": "https://www.google.com/maps/d/u/3/embed?mid=1b1273439kLELw9wSSiqD-_WhlAKGl18&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Dallas",
      "Phone": "469-640-3120",
      "Address": [
        {
          "Location1": "Dallas",
          "Address1": "5701 Maple Ave, Dallas, TX 75235",
        }
      ],
      "Map": "https://www.google.com/maps/d/u/3/embed?mid=1Jq7olr9nIOOlBvrge9gBtQZ1gv38eSk&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Atlanta",
      "Phone": "678-607-9539",
      "Address": [
        {
          "Location1": "Atlanta",
          "Address1": "1200 White St SW, Atlanta, GA 30310",
        }
      ],
      "Map": "https://www.google.com/maps/d/u/3/embed?mid=1sIJWXQRLTPmw4YVHmgahsrJWSgd1VEM&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "San Fransisco",
      "Phone": "415-539-2623",
      "Address": [
        {
          "Location1": "San Fransisco",
          "Address1": "1485 Bay Shore Blvd, San Francisco, CA 94124",
        },
        {
          "Location1": "Sacramento",
          "Address1": "2120 P St, Sacramento, CA 95816",
        },
      ],
      "Map": "https://www.google.com/maps/d/u/3/embed?mid=1P2j6c4nBHDRM-AtgEDKq0HXXFq0TcIM&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "San Jose",
      "Phone": "408-549-7034",
      "Address": [
        {
          "Location1": "San Jose",
          "Address1": "695 N 1st St, San Jose, CA 95112",
        }
      ],
      "Map": "https://www.google.com/maps/d/u/3/embed?mid=1VTJ5eC5cJ1lvDHm3-xJ-8DaTl412cv8&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Detroit",
      "Phone": "313-513-2497",
      "Address": [
        {
          "Location1": "Detroit",
          "Address1": "438 Macomb St, Detroit, MI 48226",
        }
      ],
      "Map": "https://www.google.com/maps/d/u/3/embed?mid=1EbsUpXTpW8B457T-xz2aBMfyTDb7EYs&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "New York",
      "Phone": "516-407-7717",
      "Address": [
        {
          "Location1": "New York",
          "Address1": "10657 160th St, Jamaica, NY 11433",
        },
        {
          "Location1": "Farmingdale",
          "Address1": "2357 Broadhollow Rd, Farmingdale, NY 11735",
        },
      ],
      "Map": "https://www.google.com/maps/d/u/3/embed?mid=17OjSFSNGhqK3w-aOCSkHNgDzV8ybfjc&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Ohio",
      "Phone": "330-748-3351",
      "Address": [
        {
          "Location1": "Fort Wayne",
          "Address1": "6069 Stellhorn Rd, Fort Wayne, IN 46815",
        },
        {
          "Location1": "Toledo",
          "Address1": "5153 Glendale Ave, Toledo, OH 43614",
        },
        {
          "Location1": "Dayton",
          "Address1": "3739 Inpark Cir, Dayton, OH 45414",
        },
      ],
      "Map": "https://www.google.com/maps/d/u/3/embed?mid=1T_-ChddVtp0sNncfKQ1_eqiV2h6tCxc&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Philadelphia",
      "Phone": "215-515-6658",
      "Address": [
        {
          "Location1": "Philadelphia",
          "Address1": "1501 N Broad St, Philadelphia, PA 19122",
        },
      ],
      "Map": "https://www.google.com/maps/d/u/3/embed?mid=1D8wzDRrVB_qzrwo_8RkQA30RgZu0Q2I&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Maryland",
      "Phone": "443-551-2220",
      "Address": [
        {
          "Location1": "College Park",
          "Address1": "4907 Niagara Rd, College Park, MD 20740",
        },
      ],
      "Map": "https://www.google.com/maps/d/u/3/embed?mid=1hFBKavqDPHMd0GUtJ-dU5YcIwaZPHZg&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Miami",
      "Phone": "786-668-2142",
      "Address": [
        {
          "Location1": "Miami",
          "Address1": "7275 NW 1st Ct, Miami, FL 33150",
        },
      ],
      "Map": "https://www.google.com/maps/d/u/3/embed?mid=1-hiS50ZCrpLPWXbYvKYv5tJyxeyogbo&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Sacramento",
      "Phone": "916-894-8745",
      "Address": [
        {
          "Location1": "Sacramento",
          "Address1": "646 El Camino Ave, Sacramento, CA 95815",
        },
      ],
      "Map": "https://www.google.com/maps/d/u/3/embed?mid=1f4Ra1abEjnnszAfIdOD2KJJTEde07R0&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Cleveland",
      "Phone": "216-677-4767",
      "Address": [
        {
          "Location1": "Cleveland",
          "Address1": "323 W Lakeside Ave, Cleveland, OH 44113",
        },
      ],
      "Map": "https://www.google.com/maps/d/u/0/embed?mid=1yNBBqJvjaTYSULO-rnfEyRDfpLDl8_k&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Pittsburgh",
      "Phone": "412-838-4350",
      "Address": [
        {
          "Location1": "Pittsburgh",
          "Address1": "503 Martindale St, Pittsburgh, PA 15212",
        },
      ],
      "Map": "https://www.google.com/maps/d/u/4/embed?mid=1BApI-jAERBFAmwEZFhwS147kwCJzpQo&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Boston",
      "Phone": "857-707-3716",
      "Address": [
        {
          "Location1": "Boston",
          "Address1": "350 Longwood Ave, Boston, MA 02115",
        },
      ],
      "Map": "https://www.google.com/maps/d/u/4/embed?mid=1yho9ZClpYYs5-XVsvPoakgClI1cGW00&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Knoxville",
      "Phone": "865-234-9882",
      "Address": [
        {
          "Location1": "Knoxville",
          "Address1": "311 Highway Ave, Knoxville, TN 37920",
        },
      ],
      "Map": "https://www.google.com/maps/d/u/4/embed?mid=18WO5IaIoTUxbT94-cyxay_cSjU7MG0I&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Phoenix",
      "Phone": "602-536-8731",
      "Address": [
        {
          "Location1": "Phoenix",
          "Address1": "4116 N 7th Ave, Phoenix, AZ 85013",
        },
      ],
      "Map": "https://www.google.com/maps/d/u/4/embed?mid=1Msxuhd3bUNheRJDX7TytN94Bb4yvMdE&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Providence",
      "Phone": "401-681-8349",
      "Address": [
        {
          "Location1": "Providence",
          "Address1": "1590 S County Trl, East Greenwich, RI 02818",
        },
      ],
      "Map": "https://www.google.com/maps/d/u/3/embed?mid=19sCpvNHfs2nsnb7gXqYazMcVaDPtlMg&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Columbus",
      "Phone": "614-819-3178",
      "Address": [
        {
          "Location1": "Columbus",
          "Address1": "83 S 4th St, Columbus, OH 43215",
        },
      ],
      "Map": "https://www.google.com/maps/d/u/3/embed?mid=1KeRefWQyo4xvm94KiIaEAD-I1Tv-ipU&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "New Orleans",
      "Phone": "504-514-8917",
      "Address": [
        {
          "Location1": "New Orleans",
          "Address1": "2728 Decatur St, Kenner, LA 70062",
        },
      ],
      "Map": "https://www.google.com/maps/d/u/3/embed?mid=1rsEp_U1z2D1tFONzYAHz4kUdWNvRNSw&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Milwaukee",
      "Phone": "414-348-5105",
      "Address": [
        {
          "Location1": "Milwaukee",
          "Address1": "2500 W Layton Ave, Milwaukee, WI 53221",
        },
      ],
      "Map": "https://www.google.com/maps/d/u/3/embed?mid=1UhLnu-LJ2ZJs75rlYEslvH_k0rwDywQ&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Raleigh",
      "Phone": "919-804-0651",
      "Address": [
        {
          "Location1": "Raleigh",
          "Address1": "3700 Six Forks Rd, Raleigh, NC 27609",
        },
      ],
      "Map": "https://www.google.com/maps/d/u/3/embed?mid=1mU80sHsrx3sajxGM2kUjBAflBUJSYbU&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Birmingham",
      "Phone": "205-793-6016",
      "Address": [
        {
          "Location1": "Birmingham",
          "Address1": "1157 Bankhead Hwy W, Birmingham, AL 35204",
        },
      ],
      "Map": "https://www.google.com/maps/d/u/3/embed?mid=1QR-lb-vzRwo6JqsxoALu0-j4RXq8Hcw&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "San Diego",
      "Phone": "619-983-0939",
      "Address": [
        {
          "Location1": "San Diego",
          "Address1": "8745 Aero Dr, San Diego, CA 92123",
        },
      ],
      "Map": "https://www.google.com/maps/d/u/3/embed?mid=1t041CxbPzWmdnVenmhzZGIwlfxETi7E&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Norfolk",
      "Phone": "757-835-3367",
      "Address": [
        {
          "Location1": "Norfolk",
          "Address1": "160 Newtown Rd, Virginia Beach, VA 23462",
        },
      ],
      "Map": "https://www.google.com/maps/d/u/3/embed?mid=1QR-lb-vzRwo6JqsxoALu0-j4RXq8Hcw&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Cincinnati",
      "Phone": "513-998-6316",
      "Address": [
        {
          "Location1": "Cincinnati",
          "Address1": "4960 Ridge Ave, Cincinnati, OH 45209",
        },
      ],
      "Map": "https://www.google.com/maps/d/u/3/embed?mid=1007Wevk9UO7H_NF5el9BicLFmUCr-Ms&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Monsey",
      "Phone": "845-622-7748",
      "Address": [
        {
          "Location1": "Monsey",
          "Address1": "85 Chestnut Ridge Rd, Montvale, NJ 07645",
        },
      ],
      "Map": "https://www.google.com/maps/d/u/3/embed?mid=1ruNj0ARlxKW5nXKHT2J5OGeA8b-03pU&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Portland",
      "Phone": "503-476-3888",
      "Address": [
        {
          "Location1": "Portland",
          "Address1": "4425 NE Broadway St, Portland, OR 97213",
        },
      ],
      "Map": "https://www.google.com/maps/d/u/3/embed?mid=1rNiB_ySheM5dd5ID9EUfOFilUjFg0UQ&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "West Palm Beach",
      "Phone": "561-517-9768",
      "Address": [
        {
          "Location1": "West Palm Beach",
          "Address1": "927 45th St, West Palm Beach, FL 33407",
        },
      ],
      "Map": "https://www.google.com/maps/d/u/3/embed?mid=1NJytl2FwaGzC4bZ4vu2TbXZrkrMj4GA&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Oklahoma City",
      "Phone": "405-725-2220",
      "Address": [
        {
          "Location1": "Oklahoma City",
          "Address1": "3810 N Tulsa Ave, Oklahoma City, OK 73112",
        },
      ],
      "Map": "https://www.google.com/maps/d/u/3/embed?mid=1fUVMVNlHc47pYNN1YR46BQkF23pryl0&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Indianapolis",
      "Phone": "317-648-2805",
      "Address": [
        {
          "Location1": "Indianapolis",
          "Address1": "5935 S Emerson Ave, Indianapolis, IN 46237",
        },
      ],
      "Map": "https://www.google.com/maps/d/u/1/embed?mid=1BxTUns9WQX4vztBWS0UhLcOlK7kBHJU&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Louisville",
      "Phone": "502-557-1324",
      "Address": [
        {
          "Location1": "Louisville",
          "Address1": "2420 Frankfort Ave, Louisville, KY 40206",
        },
      ],
      "Map": "https://www.google.com/maps/d/u/1/embed?mid=1ifIMqzL5jRSg4NBMY_bdONq36UDzm_Q&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Salt Lake City",
      "Phone": "801-396-9947",
      "Address": [
        {
          "Location1": "Salt Lake City",
          "Address1": "325 Hope Ave, Salt Lake City, UT 84115",
        },
      ],
      "Map": "https://www.google.com/maps/d/u/1/embed?mid=1R-XIKyV0rDl14--MUC00lCdUgK-Nr48&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Las Vegas",
      "Phone": "702-919-5469",
      "Address": [
        {
          "Location1": "Las Vegas",
          "Address1": "3010 W Charleston Blvd, Las Vegas, NV 89102",
        },
      ],
      "Map": "https://www.google.com/maps/d/u/1/embed?mid=1t-jtHfJK5Pq0xkWOB0jNOUptMN3kb9Y&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Pensacola",
      "Phone": "850-719-7143",
      "Address": [
        {
          "Location1": "Pensacola",
          "Address1": "5151 N 9th Ave, Pensacola, FL 32504",
        },
      ],
      "Map": "https://www.google.com/maps/d/u/1/embed?mid=1aDnrWu--AvpT-KgjgOFvDld9uf0bWOo&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Columbia SC",
      "Phone": "803-618-0915",
      "Address": [
        {
          "Location1": "Columbia SC",
          "Address1": "301 Greystone Blvd, Columbia, SC 29210",
        },
      ],
      "Map": "https://www.google.com/maps/d/u/1/embed?mid=1FLOLJRWgTSK4Al9racgtAgroV1Al0ho&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Greenville",
      "Phone": "864-651-4185",
      "Address": [
        {
          "Location1": "Greenville",
          "Address1": "477 Haywood Rd, Greenville, SC 29607",
        },
      ],
      "Map": "https://www.google.com/maps/d/u/1/embed?mid=14Bfv3ruWHSMU-yNNygyhlY0NlPf67bE&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Albuquerque",
      "Phone": "505-278-7461",
      "Address": [
        {
          "Location1": "Albuquerque",
          "Address1": "400 Gold Ave SW, Albuquerque, NM 87102",
        },
      ],
      "Map": "https://www.google.com/maps/d/u/1/embed?mid=1QPWWvAkdgh-wHkZSG4cC8aTjdbhP3J4&ehbc=2E312F&noprof=1",
    },
        {
      "Location": "Chattanooga",
      "Phone": "423-373-7508",
      "Address": [
        {
          "Location1": "Chattanooga",
          "Address1": "2101 Chestnut St, Chattanooga, TN 37408",
        },
      ],
      "Map": "https://www.google.com/maps/d/u/1/embed?mid=1S1zsAvFNLN37TC8Ih0IstKmAfAxYN4M&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "Tuscon",
      "Phone": "520-214-0619",
      "Address": [
        {
          "Location1": "Tuscon",
          "Address1": "3594 E Lincoln St, Tucson, AZ 85714",
        },
      ],
      "Map": "https://www.google.com/maps/d/u/1/embed?mid=1-Qija8eglCmUNxUDpZux8pj-bH3GQiQ&ehbc=2E312F&noprof=1",
    },
    {
      "Location": "San Antonio",
      "Phone": "210-625-8162",
      "Address": [
        {
          "Location1": "San Antonio",
          "Address1": "5631 University Heights Blvd, San Antonio, TX 78249",
        },
      ],
      "Map": "https://www.google.com/maps/d/u/1/embed?mid=1AuqzHiOAZMwFHM7GVKNbvpXsot3LKoQ&ehbc=2E312F&noprof=1",
    },
  ]

  return (
    <div className="App" style={false ? { "document.html.style.overflow": "hidden" } : null}>

      <Offline>
        <div className="OfflineApp">
          <h1><img src={unlock} alt="Air Duct Cleaning | Air Duct Repair | Air Duct Services | Air Duct Inspection" /><span>Internet Connection Is Not Stable.</span>Your network seems to be disconnected. Please check your internet connection.</h1>
          <img onClick={() => window.location.reload()} className='OfflineAppClose' src={reload} alt="Air Duct Cleaning | Air Duct Repair | Air Duct Services | Air Duct Inspection" />
        </div>
      </Offline>

      {/* Book an appointment */}
      {showPopUp ?
        <PopUp CitiePhone={CitiePhone} CitiesData={CitiesData} setShowPopUp={setShowPopUp} />
        : null}
      {/* Menu */}
      {showMenu ? <Menu CitiePhone={CitiePhone} navigateTo={navigateTo} setShowMenu={setShowMenu} /> : null}
      {/* Header */}
      {location.pathname == "/apply" || location.pathname == "/thankscontact" || location.pathname == "/thanks" || location.pathname.match("/portal/:*") ? null : <Header CitiePhone={CitiePhone} CitiesData={CitiesData} setShowPopUp={setShowPopUp} showMenu={showMenu} navigateTo={navigateTo} setShowMenu={setShowMenu} />}
      {/* Main */}
      <Main locationsMain2Chimney={locationsMain2Chimney} locationsMain={locationsMain} CitiePhone={CitiePhone} CitiesData={CitiesData} navigateTo={navigateTo} WebSitePages={[]} />
      {/* Footer — /local pages use the same components as the /chimney & /airduct SEO pages, which have no internal footer, so keep the global footer here (matches the header, which also shows on /local). The /book schedule page also has no internal footer, so show the global footer there too. */}
      {location.pathname == "/thanks" || location.pathname == "/thankscontact" || location.pathname.match("/portal/:*") ? null : <Footer locationsMain={locationsMain} CitiePhone={CitiePhone} navigateTo={navigateTo} />}

      {/* oNLINE */}
      {location.pathname == "/book" ? null : <a className='callButtonMainApp' href={`tel:${CitiePhone}`}> <img src={callbtn} alt="" />Click To Call!</a>}


    </div>
  );
}

export default App;
